module.exports = __webpack_public_path__ + "img/2.b2d32699.png";